(function () {
  function isExternal(href) {
    if (!href) return false;
    if (/^(mailto:|tel:|javascript:|#)/i.test(href)) return false;
    if (!/^https?:\/\//i.test(href)) return false;
    try {
      var url = new URL(href, window.location.href);
      return !!url.hostname && url.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function tagLink(a) {
    if (a.dataset.extProcessed) return;
    a.dataset.extProcessed = '1';
    if (a.target === '_blank') return;
    if (!isExternal(a.getAttribute('href'))) return;
    a.target = '_blank';
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
  }

  function scan(root) {
    var links = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) tagLink(links[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'A') tagLink(node);
        else if (node.querySelectorAll) scan(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
